(function () {
  if (window.__rotB) return; window.__rotB = true;
  var css = [
    '.rot.rot-pdp .rot-tag { background: #1D4248; padding: 4px 8px; box-shadow: 0 3px 10px rgba(29,66,72,.3); }',
    '.rot.rot-pdp .rot-tag::before { margin-right: 4px; }',
    '.rot.rot-pdp .rot-tag::after { animation: rotShineSlow 10s cubic-bezier(.4,0,.2,1) 1.2s infinite; }',
    '@keyframes rotShineSlow { 0% { left: -70%; } 16% { left: 140%; } 100% { left: 140%; } }',
    '@media (prefers-reduced-motion: reduce) { .rot.rot-pdp .rot-tag::after { animation: none; display: none; } }',
    '.rot.rot-pdp .rot-tier .s { display: inline-block; align-self: center; min-height: 0; margin-top: 3px; padding: 2px 8px; border-radius: 999px; background: rgba(59,107,80,.11); color: #2F5C43; font-weight: 600; line-height: 1.3; }',
    '.rot.rot-pdp .rot-tier .s:empty { background: none; padding: 0; }',
    '.rot-was { opacity: .5; margin-right: 6px; font-weight: 400; }',
    '.rot-now { font-weight: 600; }',
    '.rot-has-express .rot-fine { display: none; }',
    '.product-form-wrapper.rot-express { margin-top: -6px; margin-bottom: 20px; }',
    '.product-form-wrapper.rot-express .product-form__submit, .product-form-wrapper.rot-express quantity-input, .product-form-wrapper.rot-express .quantity__label, .product-form-wrapper.rot-express .quantity__rules, .product-form-wrapper.rot-express .product-form__alert, .product-form-wrapper.rot-express .shopify-payment-button__more-options { display: none !important; }',
    '.product-form-wrapper.rot-express .shopify-payment-button__button { border-radius: 12px !important; overflow: hidden; }',
    '.rot-add a.im { cursor: pointer; transition: opacity .15s; }',
    '.rot-add a.im:hover { opacity: .8; }',
    '.rot-add a.n { color: inherit; text-decoration: none; }',
    '.rot-add a.n:hover { text-decoration: underline; text-underline-offset: 3px; }',
    '@media (max-width: 767px) { cart-drawer .drawer__header { align-items: center; } cart-drawer .drawer__close { display: flex !important; width: 40px; height: 40px; min-width: 40px; padding: 0 !important; border-radius: 50% !important; flex-shrink: 0; } }'
  ].join('\n');
  var st = document.createElement('style'); st.textContent = css; document.body.appendChild(st);
  var each = function (n) { return n >= 4 ? 27.5 : n === 3 ? 30 : n === 2 ? 35 : 45; };
  var m2 = function (v) { return '$' + v.toFixed(2); };
  function prods() { var el = document.querySelector('[data-rot-products]'); try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; } }

  document.querySelectorAll('product-bundle').forEach(function (pb) {
    var totalEl = pb.querySelector('[data-product-bundle-total-with-currency]');
    var body = pb.querySelector('.product-bundle__body');
    if (!totalEl || !body) return;
    var count = function () { var t = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0; return t > 0 ? Math.round(t / 45) : 0; };
    var deco = function () {
      var n = count();
      body.querySelectorAll('[data-product-bundle-variant-content]').forEach(function (c) {
        if (c.querySelector('.horizontal-product__skeleton')) return;
        var el = c.querySelector('[data-rot-price]');
        if (!el) {
          var leaves = Array.prototype.filter.call(c.querySelectorAll('*'), function (e) { return e.children.length === 0 && /^\s*\$\s?[\d,]+(\.\d\d)?\s*$/.test(e.textContent); });
          el = leaves[leaves.length - 1]; if (!el) return;
          el.setAttribute('data-rot-price', ''); el.setAttribute('data-orig', el.textContent.trim());
        }
        var key = String(n); if (el.getAttribute('data-n') === key) return; el.setAttribute('data-n', key);
        var orig = parseFloat(el.getAttribute('data-orig').replace(/[^0-9.]/g, ''));
        if (n >= 2 && orig === 45) el.innerHTML = '<s class="rot-was">' + m2(45) + '</s><b class="rot-now">' + m2(each(n)) + '</b>';
        else el.textContent = el.getAttribute('data-orig');
      });
    };
    new MutationObserver(deco).observe(totalEl, { childList: true, characterData: true, subtree: true });
    new MutationObserver(deco).observe(body, { childList: true, subtree: true });
    deco();
  });

  var pdp = document.querySelector('.rot-pdp[data-auto]');
  var wrap = document.querySelector('#MainContent .product-form-wrapper');
  if (pdp && wrap && wrap.querySelector('.shopify-payment-button')) {
    var sync = function () {
      var t = pdp.querySelector('.rot-tier[aria-pressed="true"]');
      var one = !!t && t.getAttribute('data-n') === '1';
      wrap.classList.toggle('rot-express', one);
      pdp.classList.toggle('rot-has-express', one);
      wrap.style.display = one ? '' : 'none';
    };
    new MutationObserver(sync).observe(pdp, { childList: true });
    sync();
  }

  var cd = document.querySelector('cart-drawer');
  if (cd) {
    var linkify = function () {
      var rows = cd.querySelectorAll('[data-rot-add] li:not([data-linked])');
      if (!rows.length) return;
      var map = {}; prods().forEach(function (p) { map[p.v] = p.h; });
      rows.forEach(function (li) {
        li.setAttribute('data-linked', '');
        var b = li.querySelector('[data-rot-v]'); var h = b && map[b.getAttribute('data-rot-v')]; if (!h) return;
        var url = '/products/' + encodeURIComponent(h);
        var nm = li.querySelector('.n'); var title = nm ? nm.textContent : '';
        var im = li.querySelector('span.im');
        if (im) { var a = document.createElement('a'); a.className = 'im'; a.href = url; a.setAttribute('aria-label', 'View ' + title); while (im.firstChild) a.appendChild(im.firstChild); im.parentNode.replaceChild(a, im); }
        if (nm && nm.tagName !== 'A') { var an = document.createElement('a'); an.className = 'n'; an.href = url; an.textContent = title; nm.parentNode.replaceChild(an, nm); }
      });
    };
    new MutationObserver(linkify).observe(cd, { childList: true, subtree: true });
    linkify();
  }

  var colMap = null; try { colMap = JSON.parse(document.querySelector('[data-rot-cols]').textContent); } catch (e) {}
  if (colMap) {
    var pending = false;
    var relabel = function () {
      pending = false;
      document.querySelectorAll('.product-card__top a.caption:not([data-rot-col])').forEach(function (a) {
        a.setAttribute('data-rot-col', '');
        var card = a.closest('.product-card'); if (!card) return;
        var t = card.querySelector('a.product-card__title') || card.querySelector('a[href*="/products/"]'); if (!t) return;
        var m = (t.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/); if (!m) return;
        var c = colMap[decodeURIComponent(m[1])]; if (!c) return;
        a.href = c[1]; a.title = c[0];
        a.textContent = c[0];
      });
    };
    relabel();
    new MutationObserver(function () { if (!pending) { pending = true; requestAnimationFrame(relabel); } }).observe(document.body, { childList: true, subtree: true });
  }
})();